module.exports = __webpack_public_path__ + "static/media/news_slider_phone1.5362b81e.png";